import { render } from "./processingList.vue?vue&type=template&id=36154ac1"
import script from "./processingList.vue?vue&type=script&lang=js"
export * from "./processingList.vue?vue&type=script&lang=js"

import exportComponent from "G:\\zhongfu\\web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__